import { useQuery } from '@tanstack/react-query'

import { fetchReservationRefundEstimate } from '@/lib/venue/reservationCancelApi'
import type { ReservationRefundEstimateView } from '@/lib/venue/reservationCancelTypes'

export function reservationRefundEstimateQueryKey(venueId: string, reservationId: number) {
  return ['venue', venueId, 'reservation', reservationId, 'refund-estimate'] as const
}

/**
 * 환불 예상액 조회 (#672 요구 ①).
 *
 * 🚨 `enabled`가 모달 오픈 상태와 묶인다 — 화면 진입 시 미리 부르지 않고, 취소 모달이 열려 있는 동안만
 * 조회한다(응답이 `baseTime` 기준 예상치라 캐시해서 재사용하면 안 되기 때문 — 서버 KDoc 명시).
 */
export function useReservationRefundEstimate(venueId: string, reservationId: number, enabled: boolean) {
  return useQuery<ReservationRefundEstimateView>({
    queryKey: reservationRefundEstimateQueryKey(venueId, reservationId),
    queryFn: () => fetchReservationRefundEstimate(venueId, reservationId),
    enabled,
  })
}
